export const ADMIN_ROUTE_PATHS = {
  dashboard: '/',
  createHub: '/create',
  listHub: '/list',
  linkHub: '/link',
  diaryHub: '/diary',
  trashHub: '/trash',
  institutionsList: '/institutions/list',
  institutionCreate: '/institutions/create',
  institutionBasicData: '/institutions/basic-data',
  usersList: '/users/list',
  usersTrash: '/users/trash',
  userCreate: '/users/create',
  studentsList: '/students/list',
  studentsTrash: '/students/trash',
  studentCreate: '/users/create',
  teachersList: '/teachers/list',
  teachersTrash: '/teachers/trash',
  teacherCreate: '/users/create',
  supportStaffList: '/support-staff/list',
  supportStaffTrash: '/support-staff/trash',
  supportStaffCreate: '/users/create',
  guardiansList: '/guardians/list',
  guardiansTrash: '/guardians/trash',
  guardianCreate: '/users/create',
  classesList: '/classes/list',
  classesTrash: '/classes/trash',
  classCreate: '/classes/create',
  enrollmentsList: '/enrollments/list',
  transfersList: '/transfers/list',
  transferCreate: '/transfers/create',
  enrollmentCreate: '/enrollments/create',
  classTeachersList: '/class-teachers/list',
  classTeacherCreate: '/class-teachers/create',
  academicCoursesList: '/academic-courses/list',
  academicCoursesTrash: '/academic-courses/trash',
  academicCourseCreate: '/academic-courses/create',
  subjectsList: '/subjects/list',
  subjectsTrash: '/subjects/trash',
  subjectCreate: '/subjects/create',
  coursesList: '/courses/list',
  schoolCalendarsList: '/school-calendars/list',
  schoolCalendarCreate: '/school-calendars/create',
  schoolCalendarUpdate: '/school-calendars/update',
  schoolCalendarDetails: '/school-calendars/details',
  studentGuardiansList: '/student-guardians/list',
  studentGuardianCreate: '/student-guardians/create',
  studentGuardianUpdate: '/student-guardians/update',
  studentGuardianDetails: '/student-guardians/details',
  /** @deprecated Use schoolAccessDesk - redirects keep /pickup-desk working */
  pickupDesk: '/school-access/desk',
  pickupDeskCreate: '/school-access/authorizations/create',
  pickupDeskUpdate: '/school-access/authorizations/update',
  pickupDeskScan: '/school-access/entry/scan',
  pickupDeskMyQr: '/school-access/authorizations/my-qr',
  schoolAccess: '/school-access/dashboard',
  schoolAccessDashboard: '/school-access/dashboard',
  schoolAccessDesk: '/school-access/desk',
  schoolAccessAuthCreate: '/school-access/authorizations/create',
  schoolAccessAuthUpdate: '/school-access/authorizations/update',
  schoolAccessPickupMyQr: '/school-access/authorizations/my-qr',
  schoolAccessEntryScan: '/school-access/entry/scan',
  schoolAccessEntryConfirm: '/school-access/entry/confirm',
  schoolAccessExitList: '/school-access/exit/list',
  schoolAccessExitCreate: '/school-access/exit/create',
  schoolAccessExitUpdate: '/school-access/update',
  schoolAccessExitConfirm: '/school-access/exit/confirm',
  schoolAccessExitMyQr: '/school-access/exit/my-qr',
  schoolAccessHistory: '/school-access/history',
  schoolExit: '/school-exit/list',
  schoolExitCreate: '/school-exit/create',
  schoolExitUpdate: '/school-exit/update',
  schoolExitScan: '/school-access/entry/scan',
  schoolExitMyQr: '/school-exit/my-qr',
  attendancesList: '/attendances/list',
  attendancesDetails: '/attendances/details',
  attendancesPerformance: '/attendances/performance',
  gradesList: '/grades/list',
  reportCardsList: '/report-cards/list',
  reportCardDetails: '/report-cards/details',
  reportsList: '/reports/list',
  reportsStudent: '/reports/student',
  reportsClass: '/reports/class',
  schoolDocumentsList: '/school-documents/list',
  schoolDocumentsEmit: '/school-documents/emit',
  schoolDocumentsHistoryTexts: '/school-documents/history-texts',
  censusForm: '/census/form',
  guardianConsentsList: '/guardian-consents/list',
  classDiaryList: '/class-diary/list',
  classDiaryDetails: '/class-diary/details',
  classDiaryCreate: '/class-diary/create',
  classDiaryUpdate: '/class-diary/update',
  classDiaryView: '/class-diary/view',
  lessonPlansList: '/lesson-plans/list',
  lessonPlansDetails: '/lesson-plans/details',
  lessonPlansCreate: '/lesson-plans/create',
  lessonPlansUpdate: '/lesson-plans/update',
  lessonPlansView: '/lesson-plans/view',
  lessonPlanTemplatesCreate: '/lesson-plans/templates/create',
  lessonPlanTemplatesUpdate: '/lesson-plans/templates/update',
  lessonPlanTemplatesApply: '/lesson-plans/templates/apply',
  classSchedulesList: '/class-schedules/list',
  classScheduleCreate: '/class-schedules/create',
  classScheduleDetails: '/class-schedules/details',
  classroomSeatingList: '/classroom-seating/list',
  classroomSeatingDetails: '/classroom-seating/details',
  classroomSeatingLogs: '/classroom-seating/logs',
  setupWizard: '/setup-wizard',
  settings: '/settings',
  profile: '/profile',
  profileEdit: '/profile/edit',
  notificationsList: '/notifications',
  notificationsTrash: '/notifications/trash',
  ticketsList: '/tickets/list',
  ticketCreate: '/tickets/create',
  systemLogsList: '/system-logs',
  platformSearch: '/search',
  login: '/login',
} as const;

export const ADMIN_ROUTE_COMMANDS = {
  dashboard: ['/'] as const,
  createHub: ['/create'] as const,
  listHub: ['/list'] as const,
  linkHub: ['/link'] as const,
  diaryHub: ['/diary'] as const,
  trashHub: ['/trash'] as const,
  institutionsList: ['/institutions/list'] as const,
  institutionCreate: ['/institutions/create'] as const,
  institutionBasicData: ['/institutions/basic-data'] as const,
  institutionUpdate: (id: string) => ['/institutions/update', id] as const,
  institutionDetails: (id: string) => ['/institutions/details', id] as const,
  usersList: ['/users/list'] as const,
  usersTrash: ['/users/trash'] as const,
  userCreate: ['/users/create'] as const,
  studentsList: ['/students/list'] as const,
  studentsTrash: ['/students/trash'] as const,
  studentCreate: ['/users/create'] as const,
  teachersList: ['/teachers/list'] as const,
  teachersTrash: ['/teachers/trash'] as const,
  teacherCreate: ['/users/create'] as const,
  supportStaffList: ['/support-staff/list'] as const,
  supportStaffTrash: ['/support-staff/trash'] as const,
  supportStaffCreate: ['/users/create'] as const,
  guardiansList: ['/guardians/list'] as const,
  guardiansTrash: ['/guardians/trash'] as const,
  guardianCreate: ['/users/create'] as const,
  userUpdate: (id: string) => ['/users/update', id] as const,
  userDetails: (id: string) => ['/users/details', id] as const,
  classesList: ['/classes/list'] as const,
  classesTrash: ['/classes/trash'] as const,
  classCreate: ['/classes/create'] as const,
  classUpdate: (id: string) => ['/classes/update', id] as const,
  classDetails: (id: string) => ['/classes/details', id] as const,
  enrollmentsList: ['/enrollments/list'] as const,
  enrollmentCreate: ['/enrollments/create'] as const,
  enrollmentUpdate: (id: string) => ['/enrollments/update', id] as const,
  enrollmentDetails: (id: string) => ['/enrollments/details', id] as const,
  transfersList: ['/transfers/list'] as const,
  transferCreate: ['/transfers/create'] as const,
  classTeachersList: ['/class-teachers/list'] as const,
  classTeacherCreate: ['/class-teachers/create'] as const,
  classTeacherUpdate: (id: string) => ['/class-teachers/update', id] as const,
  classTeacherDetails: (id: string) => ['/class-teachers/details', id] as const,
  academicCoursesList: ['/academic-courses/list'] as const,
  academicCoursesTrash: ['/academic-courses/trash'] as const,
  academicCourseCreate: ['/academic-courses/create'] as const,
  academicCourseUpdate: (id: string) =>
    ['/academic-courses/update', id] as const,
  academicCourseDetails: (id: string) =>
    ['/academic-courses/details', id] as const,
  subjectsList: ['/subjects/list'] as const,
  subjectsTrash: ['/subjects/trash'] as const,
  subjectCreate: ['/subjects/create'] as const,
  subjectUpdate: (id: string) => ['/subjects/update', id] as const,
  subjectDetails: (id: string) => ['/subjects/details', id] as const,
  coursesList: ['/courses/list'] as const,
  schoolCalendarsList: ['/school-calendars/list'] as const,
  schoolCalendarCreate: ['/school-calendars/create'] as const,
  schoolCalendarUpdate: (id: string) =>
    ['/school-calendars/update', id] as const,
  schoolCalendarDetails: (id: string) =>
    ['/school-calendars/details', id] as const,
  studentGuardiansList: ['/student-guardians/list'] as const,
  studentGuardianCreate: ['/student-guardians/create'] as const,
  studentGuardianUpdate: (id: string) =>
    ['/student-guardians/update', id] as const,
  studentGuardianDetails: (studentId: string) =>
    ['/student-guardians/details', studentId] as const,
  pickupDesk: ['/school-access/desk'] as const,
  pickupDeskCreate: ['/school-access/authorizations/create'] as const,
  pickupDeskUpdate: (id: string) =>
    ['/school-access/authorizations/update', id] as const,
  pickupDeskScan: ['/school-access/entry/scan'] as const,
  pickupDeskMyQr: ['/school-access/authorizations/my-qr'] as const,
  schoolAccess: ['/school-access/dashboard'] as const,
  schoolAccessDashboard: ['/school-access/dashboard'] as const,
  schoolAccessDesk: ['/school-access/desk'] as const,
  schoolAccessAuthCreate: ['/school-access/authorizations/create'] as const,
  schoolAccessAuthUpdate: (id: string) =>
    ['/school-access/authorizations/update', id] as const,
  schoolAccessPickupMyQr: ['/school-access/authorizations/my-qr'] as const,
  schoolAccessEntryScan: ['/school-access/entry/scan'] as const,
  schoolAccessEntryConfirm: ['/school-access/entry/confirm'] as const,
  schoolAccessExitList: ['/school-access/exit/list'] as const,
  schoolAccessExitCreate: ['/school-access/exit/create'] as const,
  schoolAccessExitUpdate: (id: string) =>
    ['/school-access/update', id] as const,
  schoolAccessExitConfirm: ['/school-access/exit/confirm'] as const,
  schoolAccessExitMyQr: ['/school-access/exit/my-qr'] as const,
  schoolAccessHistory: ['/school-access/history'] as const,
  schoolExit: ['/school-exit/list'] as const,
  schoolExitCreate: ['/school-exit/create'] as const,
  schoolExitUpdate: (id: string) => ['/school-exit/update', id] as const,
  schoolExitScan: ['/school-access/entry/scan'] as const,
  schoolExitMyQr: ['/school-exit/my-qr'] as const,
  attendancesList: ['/attendances/list'] as const,
  attendancesDetails: (classId: string) =>
    ['/attendances/details', classId] as const,
  attendancesPerformance: (classId: string) =>
    ['/attendances/performance', classId] as const,
  gradesList: ['/grades/list'] as const,
  reportCardsList: ['/report-cards/list'] as const,
  reportCardDetails: (studentId: string) =>
    ['/report-cards/details', studentId] as const,
  reportsList: ['/reports/list'] as const,
  reportsStudent: ['/reports/student'] as const,
  reportsClass: ['/reports/class'] as const,
  schoolDocumentsList: ['/school-documents/list'] as const,
  schoolDocumentsEmit: ['/school-documents/emit'] as const,
  schoolDocumentsHistoryTexts: ['/school-documents/history-texts'] as const,
  censusForm: ['/census/form'] as const,
  guardianConsentsList: ['/guardian-consents/list'] as const,
  classDiaryList: ['/class-diary/list'] as const,
  classDiaryDetails: (classId: string) =>
    ['/class-diary/details', classId] as const,
  classDiaryCreate: ['/class-diary/create'] as const,
  classDiaryUpdate: (entryId: string) =>
    ['/class-diary/update', entryId] as const,
  classDiaryView: (entryId: string) => ['/class-diary/view', entryId] as const,
  lessonPlansList: ['/lesson-plans/list'] as const,
  lessonPlansDetails: (classId: string) =>
    ['/lesson-plans/details', classId] as const,
  lessonPlansCreate: ['/lesson-plans/create'] as const,
  lessonPlansUpdate: (planId: string) =>
    ['/lesson-plans/update', planId] as const,
  lessonPlansView: (planId: string) => ['/lesson-plans/view', planId] as const,
  lessonPlanTemplatesCreate: ['/lesson-plans/templates/create'] as const,
  lessonPlanTemplatesUpdate: (templateId: string) =>
    ['/lesson-plans/templates/update', templateId] as const,
  lessonPlanTemplatesApply: (templateId: string) =>
    ['/lesson-plans/templates/apply', templateId] as const,
  classSchedulesList: ['/class-schedules/list'] as const,
  classScheduleCreate: ['/class-schedules/create'] as const,
  classScheduleDetails: (classId: string) =>
    ['/class-schedules/details', classId] as const,
  classroomSeatingList: ['/classroom-seating/list'] as const,
  classroomSeatingDetails: (classId: string) =>
    ['/classroom-seating/details', classId] as const,
  classroomSeatingLogs: ['/classroom-seating/logs'] as const,
  setupWizard: ['/setup-wizard'] as const,
  settings: ['/settings'] as const,
  profile: ['/profile'] as const,
  profileEdit: ['/profile/edit'] as const,
  notificationsList: ['/notifications'] as const,
  notificationsTrash: ['/notifications/trash'] as const,
  ticketsList: ['/tickets/list'] as const,
  ticketCreate: ['/tickets/create'] as const,
  ticketDetails: (id: string) => ['/tickets/details', id] as const,
  systemLogsList: ['/system-logs'] as const,
  platformSearch: ['/search'] as const,
  login: ['/login'] as const,
};
